export type CareerCountry = 'Saudi Arabia' | 'Egypt';
export type CareerLayer = 'current' | 'engineering' | 'foundation';

export const CURRENT_ROLE_TITLE = 'Senior Cloud & AI Apps Solution Engineer';

export interface CareerRole {
    title: string;
    startYear: string;
    country?: CareerCountry;
    summary?: string;
}

export interface CareerEntry {
    company: string;
    roles: CareerRole[];
    tenureId: string;
    logo: string;
    website: string;
    country: CareerCountry;
    layer: CareerLayer;
}

export const careerEntries: CareerEntry[] = [
    {
        company: 'Microsoft',
        roles: [
            {
                title: CURRENT_ROLE_TITLE,
                startYear: '2025',
                summary: 'Innovative AI applications connected to cloud architecture and engineering practice.',
            },
            { title: 'Senior Azure Technology Specialist - Digital & App Innovation', startYear: '2023' },
            { title: 'Cloud Solution Architect - Engineering (App Innovation)', startYear: '2022' },
            { title: 'Senior Customer Engineer - AppDev', startYear: '2020' },
            { title: 'Senior Premier Field Engineer', startYear: '2020' },
            { title: 'Premier Field Engineer', startYear: '2016' },
        ],
        tenureId: 'microsoft-2016',
        logo: `${process.env.PUBLIC_URL}/career-logos/microsoft.jpg`,
        website: 'https://www.microsoft.com/',
        country: 'Saudi Arabia',
        layer: 'current',
    },
    {
        company: 'SURE International Technology',
        roles: [{ title: 'Team Leader', startYear: '2013' }],
        tenureId: 'sure-2013',
        logo: `${process.env.PUBLIC_URL}/career-logos/sure.jpg`,
        website: 'https://sure.com.sa/en/',
        country: 'Saudi Arabia',
        layer: 'engineering',
    },
    {
        company: 'ITWORX',
        roles: [{ title: 'Senior Software Engineer', startYear: '2012' }],
        tenureId: 'itworx-2012',
        logo: `${process.env.PUBLIC_URL}/career-logos/itworx.jpg`,
        website: 'https://www.itworx.com/',
        country: 'Egypt',
        layer: 'engineering',
    },
    {
        company: 'SURE International Technology',
        roles: [
            { title: 'Technical Team Leader', startYear: '2012' },
            { title: 'Senior Software Engineer', startYear: '2011' },
        ],
        tenureId: 'sure-2011',
        logo: `${process.env.PUBLIC_URL}/career-logos/sure.jpg`,
        website: 'https://sure.com.sa/en/',
        country: 'Egypt',
        layer: 'engineering',
    },
    {
        company: 'Salis IT Services',
        roles: [{ title: 'Senior Web Developer', startYear: '2005' }],
        tenureId: 'salis-2005',
        logo: `${process.env.PUBLIC_URL}/career-logos/salis.jpg`,
        website: 'https://www.salis-it.com/',
        country: 'Egypt',
        layer: 'foundation',
    },
    {
        company: 'SEKEM',
        roles: [{ title: 'Technical Support', startYear: '2004' }],
        tenureId: 'sekem-2004',
        logo: `${process.env.PUBLIC_URL}/career-logos/sekem.png`,
        website: 'https://sekem.com/',
        country: 'Egypt',
        layer: 'foundation',
    },
];